import ajax from "./request.js";
import { HOST } from './base';

function queryList(data) {
  return ajax(`${HOST}/macVersion/list`, {
    method: "POST",
    data
  });
}

function saveData(data) {
  return ajax(`${HOST}/macVersion/save`, {
    method: "POST",
    data
  });
}

function updateData(data) {
  return ajax(`${HOST}/macVersion/update`, {
    method: "POST",
    data
  });
}

function deleteDatas(data) {
  return ajax(`${HOST}/macVersion/deleteByIds`, {
    method: "POST",
    data
  });
}

function updateStatus(data) {
  return ajax(`${HOST}/macVersion/updateStatus`, {
    method: "POST",
    data
  });
}

function findDataById(data) {
  return ajax(`${HOST}/macVersion/findById`, {
    method: "POST",
    data
  });
}

export default {
  queryList,
  saveData,
  updateData,
  deleteDatas,
  findDataById,
  updateStatus,
};
